import {
    FETCH_Global_Search_DATA_REQUEST,
    FETCH_Global_Search_DATA_SUCCESS,
    FETCH_Global_Search_DATA_FAILURE
} from "../types";

const initialState = {
    globalSearchData: null,
    // tourData: null,
    isLoading: false,
    error: null,
    status: "idle",
};

const globalSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_Global_Search_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
                status: "pending"
            };
        case FETCH_Global_Search_DATA_SUCCESS:
            return {
                ...state,
                globalSearchData: action.payload,
                // tourData: action.payload?.tour_data,
                isLoading: false,
                status: "success"
            };
        case FETCH_Global_Search_DATA_FAILURE:
            return {
                ...state,
                globalSearchData: null,
                // tourData: null,
                error: action.payload,
                isLoading: false,
                status: "failed"
            };
        default:
            return state;
    }
};

export default globalSearchReducer;
